export interface Address {
  address?: string;
  city?: string;
  country?: string;
  postcode?: string;
  state?: string;
}

export interface PostAddress {
  firstLine: string;
  secondLine: string;
  country: string;
}

/**
 * Static class with all global methods related to addresses
 * @category Formatters
 * @category Address
 */
export class AddressService {
  /**
   * Helper that formats address to a string
   * @param Address - Address object
   * @param hideIfNoAddress - boolean
   */
  static toString(
    { address = '', city, country, postcode, state }: Address,
    hideIfNoAddress = false,
  ): string {
    let formattedAddress = address;

    if (!formattedAddress && hideIfNoAddress) {
      return '';
    }

    if (city) formattedAddress += `, ${city}`;
    if (state) formattedAddress += `, ${state}`;
    if (postcode) formattedAddress += `, ${postcode}`;
    if (country) formattedAddress += `, ${country}`;

    return formattedAddress.replace(/^,\s/, '');
  }

  /**
   * Helper that formats address to the USA postal format
   * @param Address - Address object
   * @param hideIfNoAddress - boolean
   */
  static toPostal(
    { address = '', city, country, postcode, state }: Address,
    hideIfNoAddress = false,
  ): PostAddress {
    const postalAddress: PostAddress = {
      firstLine: address,
      secondLine: '',
      country: '',
    };

    if (!postalAddress.firstLine && hideIfNoAddress) {
      return postalAddress;
    }

    if (city || state) {
      postalAddress.secondLine = [city, state]
        .toString()
        .replace(/^,/, '')
        .replace(/,$/, '')
        .replace(/,/g, ', ');
    }
    if (postalAddress.secondLine && postcode) postalAddress.secondLine += ' ';
    if (postcode) postalAddress.secondLine += `${postcode}`;
    if (country) postalAddress.country = `${country}`;

    return postalAddress;
  }
}
